import styles from "Components/Dashboard/dashboard.module.scss";
import { Tooltip, Space, Typography, Card } from "antd";
import { BsFillSquareFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";

const { Text, Title } = Typography;

// 自定義標籤列表，可選擇是否添加顏色及點擊事件處理，主要用於 Dashboard 各個組件使用
// 主要用於顯示 圖標 例如 Health = { good:1 | Warning:0 | Critical:0 | offline:18 } 這段顯示組件就是 Label
export const Label = ({
  devicestatic,
  tooltip,
  onChartClick,
  color,
  legendHeight,
}: {
  devicestatic: [string, number][];
  tooltip?: string[];
  onChartClick?: any;
  color?: string[] | undefined;
  legendHeight?: Object;
}) => {
  const { t } = useTranslation();

  // 預設 icon 訊號顏色 [ "Excellent" , "Good" , "Fair" , "Poor" , "NA" ]
  const defaultColor = color ?? ["#28a745", "#ffc107", "#dc3545", "#343a40", "gray"];
  return (
    <Space align="start" style={legendHeight} size={[16, 8]} wrap className={styles.legend}>
      {devicestatic.map(([label, number], index) => (
        <Space
          align="center"
          key={index}
          className={onChartClick ? styles.legend__category : ""}
          // style={{ color: defaultColor[index] }}
          onClick={() => {
            if (!onChartClick) return;
            // 點擊觸發事件，將 點擊到的 label 資料 改為小寫
            onChartClick(undefined, label.toLowerCase());
          }}
        >
          {/* 若 Label color 沒有自訂義 則 顯示 icon 且 style = {{ color: defaultColor 顏色陣列 }}  */}
          <BsFillSquareFill style={{ color: defaultColor[index] }} />
          {/* 只有 Health(設備健康狀態) 與 Firmware(設備版本)的彈出卡片 有使用 icon 提示文字 */}
          <Tooltip title={t(tooltip ? tooltip[index] : "")}>
            {/* 顯示 標籤文字：數字    例：Excellent:0 , Good:0 , Fair:1 , Poor:0 , NA:18 */}
            <Text strong>
              {label}: {number}
            </Text>
          </Tooltip>
        </Space>
      ))}
    </Space>
  );
};
// 定義一個包含 Echarts圖表的組件，並顯示 資料總數。
// 例如 Health = { good:1 | Warning:0 | Critical:0 | offline:18 } 資料總數 = 19
export const ChartContainer = ({ children, sum }: { children: React.ReactNode; sum: number }) => {
  return (
    <div className={styles.pie}>
      <Title
        // 圖表內的數字樣式大小 level= {3} 等於 <h3>
        level={3}
        // style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", color: "#002FA7" }}
        className={styles.pie__title}
      >
        {/* 顯示圖表內的數字 */}
        {sum}
      </Title>
      {/* 這裡的children 用來顯示圖表的組件，通常引入<ReactECharts/> 來顯示圖表的圓餅圖示
      <ChartContainer sum={tableData.length}>
        <ReactECharts/>
      </ChartContainer> */}
      {children}
    </div>
  );
};

type CardProps = React.ComponentProps<typeof Card>;

interface DashCardProps extends CardProps {
  title: string;
  children: React.ReactNode;
  extra?: React.ReactNode;
}

// 自定義一個自訂義樣式的卡片，包括標題、樣式、額外內容等，為 Dashboard 各個組件的圖表主架構
{
  /* 插入 i18n 顯示 標題欄位，由各組件引用時輸入該組件標題，
          例：Firmware 組件 
          <DashCard title={Firmware}>
            <Label/>
            <ChartContainer/>
          </DashCard> */
}
export const DashCard = ({ title, children, bodyStyle, extra }: DashCardProps) => {
  const { t } = useTranslation();
  return (
    <Card
      title={
        <Title style={{ color: "#FFFFFF" }} level={4}>
          {t(`ISMS.${title}`)}
        </Title>
      }
      className={styles.Card}
      // 標題樣式
      headStyle={{
        backgroundColor: "#002FA7",
        color: "white",
        textAlign: "center",
      }}
      /* bodyStyle 樣式：
      padding: 3： 內邊距 為 3，
      height: "303px"：高度拉至為 303px，
      ...bodyStyle 使用展開運算符，將 bodyStyle 中，原本定義的 padding、height 樣式屬性擴展到最終的 bodyStyle 中。
      例如：bodyStyle = { backgroundColor: "gray" }；最終 bodyStyle = { padding: 3, height: "303px", backgroundColor: "gray" } */
      bodyStyle={{ padding: 3, height: "303px", ...bodyStyle }}
      // 卡片上方 添加元素，通常為按鈕、圖標、其他操作相關內容。
      extra={extra}
    >
      {/*加入{children} 能接受任何 React 元素，包括文字、組件、陣列等，這些內容都會透過 {children} 存取與渲染 
      例如 <DashCard title="My Card">This is some text content.</DashCard>，若沒有 {children} 則不會渲染內部文字或組件*/}
      {children}
    </Card>
  );
};
